import { ITermsAndConditionParams } from './types';

export const termsAndConditionUrl = ({
  countryCode,
  language,
}: ITermsAndConditionParams) =>
  `/web/assets/artifacts/pages/terms-${countryCode}-${language}.json`;

export const appConfigurationUrl = () => '/public.json';
